import { Component } from '@angular/core';

@Component({
    selector: 'counter',
    template: require('./counter.component.html')
})
export class CounterComponent {
    public currentCount = 0;

    public incrementCounter() {
        this.currentCount++;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/counter/counter.component.ts